export const getLatestApprovedTransaction = async (
  investedAmount,
  fundName,
  userID
) => {
  try {
    const transactions = await investedAmount
      .where("clientDetails.userUid", "==", userID)
      .where("status", "==", "approved")
      .orderBy("datePlaced", "desc")
      .get();

    const fundTransaction = transactions.docs.find(
      (doc) => doc.data().fundDetails?.fundName === fundName
    );
    return fundTransaction ? fundTransaction.data() : null;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};
